import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { readLaunchEnv } from './env'
import { setLocale } from './i18n/locale'
import './styles.css'

// Before the first render, not inside it: a screen that paints in English and then switches is
// worse than one that was never English. cTrader's `lang` is the only source — there is no
// picker, because cTrader already answers that question for the whole terminal.
const locale = setLocale(readLaunchEnv().lang)
document.documentElement.lang = locale.tag

const root = document.getElementById('root')
if (!root) throw new Error('#root missing from index.html')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
